import {createFileRoute, redirect} from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/auth/login')({
  loaderDeps: ({search}) => {
    return {search};
  },
  loader: ({deps: {search}}) => {
    throw redirect({
      to: '/auth/signin',
      search: search,
    });
  },
});
